/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1HoldEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_PORTFOLIO_V1_HOLD_EVENT_ENTITY_NAME = 'ixc.portfolio.v1.HoldEvent';
export const ixcPortfolioV1HoldEventEntity = new schema.Entity<IxcPortfolioV1HoldEvent>(IXC_PORTFOLIO_V1_HOLD_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        requested: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcPortfolioV1HoldEvent) => `${entity.metadata?.eventId}` });

